import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import Firebase from "../../firebasehelper";
import "./index.css";
const abc = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j"];
class ServiceRow extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      total: 0,
      open: 0,
      close: 0,
      waiting: 0,
      service: props.service
    };
    this.checkbox = React.createRef();
  }
  componentDidMount() {
    const { service } = this.props;
  }
  componentWillReceiveProps(nextProps) {
    const { service } = nextProps;
    this.setState({ service });
  }
  showTier2data = array => {
    const { service } = this.state;
    const { index } = this.props;
    let row_id = index;
    return array.map((item, index) => {
      const active = item.active;
      const { is_brandRouting } = service;
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          {row_id === 0 && <p>{`T2${abc[index]}`}</p>}
          {!is_brandRouting && (
            <button
              className={`${active ? "active" : "deactive"}`}
              id={index}
              onClick={() => this.toggleTier2(index)}
              style={{
                backgroundImage: `url(${item.src})`
              }}
            ></button>
          )}
          {is_brandRouting && (
            <button
              className={`branded_button ${active ? "active" : "deactive"}`}
              id={index}
              onClick={() => this.toggleTier2(index)}
            >
              <img src={item.src} alt="brand" />
              <p>{item.title}</p>
            </button>
          )}
        </div>
      );
    });
  };
  toggleTier2 = index => {
    const { toggleTier2 } = this.props;
    toggleTier2(index);
  };
  onCheck = () => {
    console.log("checked", this.checkbox.current.checked);
    // If the checkbox is checked, display the output text
    if (this.checkbox.current.checked === true) {
    } else {
    }
  };
  render() {
    const { service } = this.state;
    const { active, is_brandRouting, title } = service;
    const { toggleTier1, index } = this.props;
    return (
      <div className="service_row">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            marginRight: 20
          }}
        >
          {index === 0 && <p>Tier 1</p>}
          {!is_brandRouting && (
            <button
              className={active ? "active" : "deactive"}
              style={{
                backgroundImage: `url(${service.src})`
              }}
              onClick={toggleTier1}
            ></button>
          )}
          {is_brandRouting && (
            <button
              className={`branded_button ${active ? "active" : "deactive"}`}
              id={index}
              onClick={() => this.toggleTier2(index)}
            >
              <img src={service.src} alt="brand" />
              <p>{service.title}</p>
            </button>
          )}
        </div>

        {service.value && this.showTier2data(service.value)}
      </div>
    );
  }
}
export default ServiceRow;



// WEBPACK FOOTER //
// ./src/components/ServiceRow/index.js